import { doGet, doPost } from './http.service'
import { User } from "../types/User";

export interface LoginPayload {
    login: string,
    password: string,
    emailToUpdate: string|null
    emailCode: string|null
    auth: string|null
    requestCode: boolean
}

export interface RegisterPayload {
    login: string,
    password: string,
    username?: string,
}

export function login(payload: LoginPayload) {
    return doPost<{jwt:string, user: User}>('/auth/login', payload);
}

export function register(payload: RegisterPayload) {
    return doPost<{jwt:string, user: User}>('/auth/register', payload);
}

export function renew() {
    return doPost<{jwt:string}>('/auth/renew');
}

export function getMe() {
    return doGet<User>('/auth/me');
}

export function forgotPassword(user: {login: string}) {
    return doPost<User>('/auth/forgot-password', user);
}

export function resetPassword(user: {id: string, password: string}) {
    return doPost<{jwt:string, user: User}>('/auth/reset-password', user);
}
